import config from "@/config"
import http from "@/utils/request"
// import tool from "@/utils/tool"
export default {
  refund: {
    list: {
      url: `${config.API_URL}/refund`,
      name: "退款api",
      get: async function (params) {
        return await http.get(`${this.url}/user/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      }
    }
  }
}
